export const CONFIRMED_GET_HOW_TO_TAKES = "CONFIRMED_GET_HOW_TO_TAKES";
export const CONFIRMED_CREATE_HOW_TO_TAKE = "CONFIRMED_CREATE_HOW_TO_TAKE";
export const CONFIRMED_DELETE_HOW_TO_TAKE = "CONFIRMED_DELETE_HOW_TO_TAKE";
export const CONFIRMED_EDIT_HOW_TO_TAKE = "CONFIRMED_EDIT_HOW_TO_TAKE";
